import {Component} from "@angular/core";
import {Router} from "@angular/router";
import {TourApplicationService} from "../../service/tour-application/tour-application.service";


@Component({
  selector: 'app-tour-lookup',
  templateUrl: 'tour-lookup.component.html',
  styleUrls: ['tour-lookup.component.scss'],
  providers: [TourApplicationService]
})
export class TourLookupComponent {
  constructor(private applicationService: TourApplicationService, private router: Router) {  }

  lookup(form: any) {
    if (!form.name) {
      window.alert('이름을 입력해 주세요.');
      return;
    } else if (!form.phone) {
      window.alert('휴대폰 번호를 입력해 주세요.');
      return;
    }

    this.applicationService.lookup(form.name, form.phone).subscribe(
      applications => {
        sessionStorage.setItem('__hey_tourList', JSON.stringify(applications));
        this.router.navigate(['/tour/list'])
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/space/tour-lookup/tour-lookup.component.ts